<template>
    <div class="is-fluid">
        <div class="notification is-success" v-show="showNotification==1">
        <button class="delete" @click="showNotification=0"></button>
       Personal Details Updated Successfully
        </div>
  <ContactSubHeader @updateContactTab="updateTab" :tabToShow="this.tabToShow"></ContactSubHeader>
 <section class="section ">
    <div class="container is-fluid" v-show="tabToShow == 'personal'"> 
      <h1 class="title">Personal Details</h1>
      <form @submit.prevent="updateContact">
        <div class="columns">
        <div class="field column">
          <label class="label">First Name</label>
          <div class="control">
            <input class="input" type="text" placeholder="" v-model="contact.forename">
          </div>
        </div>
        <div class="field column">
          <label class="label">Surname</label>
          <div class="control">
            <input class="input" type="text" placeholder="" v-model="contact.surname">
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="field column">
          <label class="label">Company</label>
          <div class="control">
            <input class="input" type="text" placeholder="" v-model="contact.company">
          </div>
        </div>
        <div class="field column">
          <label class="label">Job Title</label>
          <div class="control">
            <input class="input" type="text" placeholder="" v-model="contact.job_title">
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="field column">
          <label class="label">Email</label>
          <div class="control">
            <input class="input" type="email" placeholder="" v-model="contact.email">
          </div>
        </div>
        <div class="field column">
          <label class="label">Mobile Number</label>
          <div class="control">
            <input class="input" type="text" placeholder="" v-model="contact.mobile">
          </div>
        </div>
      </div>
      

      <div class="field is-grouped">
        <p class="control">
         
          <button class="button is-link" :disabled="saving===1">
            Update
          </button>
        

        
        </p>
        <a v-bind:href="'mailto:'+ contact.email" class="button is-warning " v-if="contact.email != ''" target="_blank">
            Compose Email
          </a>

      </div>
    </form>
    </div>



    <div class="container is-fluid" v-show="tabToShow == 'funding'" > 
        <FundingTab 
        :fundings="contact.fundings"/>
    </div>

    <div class="container is-fluid" v-show="tabToShow == 'applications'"> 
        <ApplicationsTab 
        :applications="contact.applications"/>
    </div>

    <div class="container is-fluid" v-show="tabToShow == 'notes'"> 
        <NotesTab 
        :notes="contact.notes" :contact-id="contact.id" :contact="contact" @reloadContact="getContactSingle()" :accessToken="accessToken"/>
    </div>
  </section>
  </div>
</template>

<script>

import ApplicationsTab from '@/components/Contacts/ApplicationsTab';
import FundingTab from '@/components/Contacts/FundingTab';
import NotesTab from '@/components/Contacts/NotesTab';
import ContactService from '@/services/ContactService.js';
import ContactSubHeader from '@/components/Contacts/ContactSubHeader';

import ContactMixin from "@/mixins/ContactMixin.js";

export default {
  components: {
     ApplicationsTab,
     FundingTab,
     NotesTab,
     ContactSubHeader
  },
  mixins: [ContactMixin],
  data() {
    return {
      contact: [],
      errors: [],
        showNotification:0,
        tabToShow:'',
        accessToken:'',
        saving:0
    }
  },
  

  // Fetches posts when the component is created.
  created() {
    this.tabToShow = this.initialTabToShow
     this.getAccessToken()
    .then(() => { 
      this.getContactSingle();
    });
    
   
  },
  computed: {
    initialTabToShow: function () {
      if( typeof this.$route.params.tab !== 'undefined')
      {
        return this.$route.params.tab
      }
      else{
        return 'personal'
      }
    }
  },
  methods: {
  	
    
    async updateContact() {
        this.saving = 1
        
        var formdata = { 
          _method: 'patch',
          forename : this.contact.forename,
          surname : this.contact.surname,
           email : this.contact.email,
          mobile : this.contact.mobile,
          company : this.contact.company,
           job_title : this.contact.job_title
        }; 

        ContactService.updateContact(this.accessToken, this.$route.params.id, formdata)
        .then( () => { 
            this.showNotification = 1;
            this.saving = 0;
          }
        )
        .then( setTimeout(() => this.showNotification = 0, 2000) )
        .catch(error => {
          alert("An error occured - " + error.message)
          console.error(error.message);
          this.saving=0;
        });
        
    },
    updateTab(newTab)
    {
      this.tabToShow = newTab
    }
  }
}

// used to be on button  v-if="this.user["https://app.test202.co.uk/roles"].includes('sales')"
</script>

<style>
	
</style>
